import { ITabState } from '../states/tabState.model.ts';
import { customerService, Bakery2bAccountsRes } from '../services/customer.service.ts';
import { responseHandler } from '../../../shared/responseHandler/responseHandler.ts';
import { take } from 'rxjs';
import {
  configsData,
  DictBakery2bAccountsRes,
} from '../../../shared/services/configsData/configsData.service.ts';

export const defaultCustomerBakery2bData: Bakery2bAccountsRes = [];

export async function resolveDataForBakery2bTab(data: ITabState): Promise<ITabState> {
  data.bakery2bAccounts = data?.customerId
    ? await customerService.globHelpers.streamToPromise(
        customerService.sub.getCustomerBakery2bAccounts().pipe(
          responseHandler<Bakery2bAccountsRes>({
            errorReturnType: defaultCustomerBakery2bData,
          }),
          take(1),
        ),
        () => {
          customerService.pub.getCustomerBakery2bAccounts({ id: data.customerId! });
        },
      )
    : defaultCustomerBakery2bData;
  return data;
}

export async function resolveBakery2bTabOptions(data: ITabState): Promise<ITabState> {
  data.bakery2bTabOptions.bakery2bAccounts = await customerService.globHelpers.streamToPromise(
    configsData.sub
      .dictBakery2bAccounts()
      .pipe(responseHandler<DictBakery2bAccountsRes>({ errorReturnType: [] }), take(1)),
    () => configsData.pub.common(['dictBakery2bAccounts']),
  );
  return data;
}
